import { SideBarBtnType } from '@/commons/enums/side-bar-btn-type';
import './index.less';
import SideBarTool from "@/commons/components/side-bar-tool";
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { addElevatorGroup, deleteElevatorGroup, getElevatorGroups, updateElevatorGroup } from '@/api/building/elevator-group';
import { ReactComponent as LinkSvg } from '@/commons/icons/panel-icon/link.svg';
import { ElevatorGroup } from '@/commons/interface/building/elevator-group';
import { Input, Modal, message } from 'antd';
import { ReactComponent as ConfimSvg } from '@/commons/icons/marshalling/confim.svg';
import { ReactComponent as EditSvg } from '@/commons/icons/marshalling/edit.svg';
import classNames from 'classnames';
import { graphicStore } from '@/commons/store/graphic-store';
import { AddPrimitivesCommand, ModelBase } from "pytha";
import { BimModelBase, GroupType } from 'tnbimbase';
import TnModal from '@/commons/widget/base-modal';
import SelectModal from '@/commons/widget/select-modal';
import { createPrimitiveMulti } from '@/api/geometry/primitive';

// const tempFireControlElevatorGroupData: { value: string, uuid: string }[] = [
//     { value: "controlElevatorGroup_DE", uuid: "a1230a25-3805-4298-a94e-75b1c235a240" },
//     { value: "controlElevatorGroup_ny", uuid: "c12371ae-250e-4a98-9c72-e8024d214731" },
//     { value: "controlElevatorGroup_eu", uuid: "7123891c-c5e9-4798-b1bc-b3058609bb48" },
//     { value: "controlElevatorGroup_Gn", uuid: "0123786d-6346-4198-a883-780620cc02b8" },
//     { value: "controlElevatorGroup_as", uuid: "e123221f-bdc4-4a98-a9c8-afbc920091c9" },
//     { value: "controlElevatorGroup_pz", uuid: "9123e035-3508-4598-bf5d-e86694c754a5" },
//     { value: "controlElevatorGroup_hn", uuid: "c1234e1c-9986-4698-9c2c-a646d18834ag" },
//     { value: "controlElevatorGroup_NI", uuid: "01237522-62e1-4d98-81c6-0461b66905cb" },
//     { value: "controlElevatorGroup_xA", uuid: "31237a90-f9bc-4298-a325-563f03ed6e4b" },
//     { value: "controlElevatorGroup_Sg", uuid: "2123da6f-5582-4a98-b93d-5bc5b70f8df3" },
// ]

export default function ElevatorGroupPanel() {

    const { projectUuid, modelUuid } = useParams();
    const [loading, setLoading] = useState<boolean>(false);
    const [displayElevatorGroups, setDisplayElevatorGroups] = useState<ElevatorGroup[]>([]);
    const [activeElevatorGroup, setActiveElevatorGroup] = useState<ElevatorGroup>();
    const [editElevatorGroupUuid, setEditElevatorGroupUuid] = useState<string>('');
    const [editElevatorGroupName, setEditElevatorGroupName] = useState<string>('');
    const [showAddElevatorGroup, setShowAddElevatorGroup] = useState<boolean>(false);
    const [showBtnGroup, setShowBtnGroup] = useState<boolean>(false);

    const [modalOpen, setModalOpen] = useState<boolean>(false)

    useEffect(() => {
        getElevatorGroups(projectUuid, modelUuid).then(res => {
            if (res.status === 200) {
                let displayElevatorGroups: ElevatorGroup[] = res.data || [];
                setDisplayElevatorGroups(displayElevatorGroups);
            }
        })
    }, [projectUuid, modelUuid])

    const onConfirmLink = (e: string) => {
        if (!(e?.length > 0)) return
        let entities: ModelBase[] = activeElevatorGroup?.primitiveUuids?.map(uuid => graphicStore.extraContext.getCurrentViewEditor().entityDict[uuid]);
        let saveJsonList = []
        for (let i = 0; i < entities.length; i++) {
            // createPrimitive
            let data = { ...entities[i]?.extraData || {}, fireControlElevatorGroupUuid: e }
            entities[i].extraData = data
            saveJsonList.push(entities[i].toJson())
        }
        createPrimitiveMulti(saveJsonList, { modelUuid: modelUuid, projectUuid: projectUuid }).catch((e) => {
            message.error("更新失败！")
        })
    }

    const onClickLink = () => {
        setModalOpen(true)
    }


    const onDeleteClick = () => {
        if (!activeElevatorGroup) {
            message.warning("没有选中全楼电梯");
            return;
        }
        TnModal().deleteModal({
            closable: false,
            onOk() {
                deleteElevatorGroup(projectUuid, activeElevatorGroup.uuid).then(res => {
                    message.success("删除成功");
                    // 1 去除属性
                    let idx = displayElevatorGroups.findIndex(item => item.uuid === activeElevatorGroup.uuid);
                    let elevatorGroup = displayElevatorGroups[idx];
                    let priUuids = elevatorGroup?.primitiveUuids || [];
                    if (priUuids?.length > 0) {
                        let newEntities = [];
                        for (let uuid of priUuids) {
                            let entity = graphicStore.extraContext.getCurrentViewEditor().entityDict[uuid];
                            if (!(entity as BimModelBase).group[GroupType.ELEVATOR_GROUP]) {
                                continue;
                            }
                            let groupUuids = (entity as BimModelBase).group[GroupType.ELEVATOR_GROUP];
                            groupUuids = groupUuids?.filter(item => item !== activeElevatorGroup.uuid) || [];
                            (entity as BimModelBase).group[GroupType.ELEVATOR_GROUP] = groupUuids;
                            newEntities.push(entity);
                        }
                        new AddPrimitivesCommand(newEntities).execute();
                    }
                    // 2 修改列表
                    displayElevatorGroups.splice(idx, 1);
                    setDisplayElevatorGroups([...displayElevatorGroups]);

                }).finally(() => {
                    setActiveElevatorGroup(null);
                    Modal.destroyAll();
                })
            },
            onCancel() {
                Modal.destroyAll();
            },
        })
    }

    const onElevatorGroupClick = (sub) => {
        setActiveElevatorGroup(sub);
        let entities: ModelBase[] = sub?.primitiveUuids?.map(uuid => graphicStore.extraContext.getCurrentViewEditor().entityDict[uuid]);
        graphicStore.extraContext.getCurrentViewEditor().listeners.signals.emptySelectedEntities.dispatch();
        if (entities?.length > 0) {
            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.forceEntitiesSelected.dispatch(entities);
        }
    }

    const onAddBtnClick = () => {
        setEditElevatorGroupName("");
        setEditElevatorGroupUuid("");
        setShowAddElevatorGroup(true);
    }

    const onAddSave = () => {
        if (!projectUuid || !modelUuid) return;
        if (loading) return;
        if (!editElevatorGroupName) {
            setEditElevatorGroupName("");
            setShowAddElevatorGroup(false);
            return;
        }
        setLoading(true);
        let data: ElevatorGroup = {
            projectUuid: projectUuid,
            modelUuid: modelUuid,
            name: editElevatorGroupName,
        }
        addElevatorGroup(projectUuid, modelUuid, data).then(res => {
            if (res.status === 200) {
                let uuid = res.data;
                message.success("添加成功");
                data.uuid = uuid;
                displayElevatorGroups.push(data);
                setDisplayElevatorGroups([...displayElevatorGroups]);
            }
        }).catch(() => {
            message.error("添加失败");
        }).finally(() => {
            setLoading(false);
            setShowAddElevatorGroup(false);
            setEditElevatorGroupName("");
            setEditElevatorGroupUuid("");
        })
    }

    const onElevatorGroupEditClick = (elevatorGroup: ElevatorGroup) => {
        setEditElevatorGroupUuid(elevatorGroup.uuid);
        setEditElevatorGroupName(elevatorGroup.name);
        setActiveElevatorGroup(elevatorGroup);
        setShowBtnGroup(true);
        let entities: ModelBase[] = elevatorGroup?.primitiveUuids?.map(uuid => graphicStore.extraContext.getCurrentViewEditor().entityDict[uuid]);
        if (entities?.length > 0) {
            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.emptySelectedEntities.dispatch();
            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.forceEntitiesSelected.dispatch(entities);
            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onCursorChange.dispatch(3);
        }
    }

    const onSave = () => {
        // 1.获取当前选中的图元
        let selectedList = graphicStore.extraContext.getCurrentViewEditor().selectControl.getSelectedEntityList();
        let newPriUuids: string[] = selectedList?.map(item => item.uuid) || [];
        let activeElevatorGroupUuids = new Set(activeElevatorGroup?.primitiveUuids || []);
        let newPriUuidsSet = new Set(newPriUuids);
        let addedUuids = newPriUuids.filter(uuid => !activeElevatorGroupUuids.has(uuid));
        let removedUuids = [...activeElevatorGroupUuids].filter(uuid => !newPriUuidsSet.has(uuid));

        // 2.传递参数回去
        let data: ElevatorGroup = {
            ...activeElevatorGroup,
            name: editElevatorGroupName,
        }
        // 3.修改api 同步修改图元属性
        updateElevatorGroup(activeElevatorGroup.uuid, data).then(res => {
            if (res.status === 200) {
                // 1 修改图元属性（旧的需要删除属性，新的需要新增属性）
                let newEntities = [];
                for (let uuid of addedUuids) {
                    let entity = graphicStore.extraContext.getCurrentViewEditor().entityDict[uuid];
                    if (!(entity as BimModelBase).group[GroupType.ELEVATOR_GROUP]) {
                        (entity as BimModelBase).group[GroupType.ELEVATOR_GROUP] = [];
                    }
                    let groupUuids = (entity as BimModelBase).group[GroupType.ELEVATOR_GROUP] || [];
                    groupUuids.push(activeElevatorGroup.uuid);
                    (entity as BimModelBase).group[GroupType.ELEVATOR_GROUP] = groupUuids;
                    newEntities.push(entity);
                }

                for (let uuid of removedUuids) {
                    let entity = graphicStore.extraContext.getCurrentViewEditor().entityDict[uuid];
                    if (!(entity as BimModelBase).group[GroupType.ELEVATOR_GROUP]) {
                        continue;
                    }
                    let groupUuids = (entity as BimModelBase).group[GroupType.ELEVATOR_GROUP];
                    groupUuids = groupUuids?.filter(item => item !== activeElevatorGroup.uuid) || [];
                    (entity as BimModelBase).group[GroupType.ELEVATOR_GROUP] = groupUuids;
                    newEntities.push(entity);
                }
                new AddPrimitivesCommand(newEntities).execute();
                // 2 修改列表
                let idx = displayElevatorGroups?.findIndex(item => item.uuid === activeElevatorGroup.uuid);
                displayElevatorGroups[idx].primitiveUuids = newPriUuids;
                displayElevatorGroups[idx].name = editElevatorGroupName;
                setDisplayElevatorGroups([...displayElevatorGroups]);
                message.success("编辑成功");

            }
        }).catch(err => {
            console.log('err', err)
            message.error("编辑失败");
        }).finally(() => {
            onCancel();
        })
    }

    const onCancel = () => {
        setEditElevatorGroupName("");
        setEditElevatorGroupUuid("");
        setShowBtnGroup(false);
        graphicStore.extraContext.getCurrentViewEditor().listeners.signals.emptySelectedEntities.dispatch();
        graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onCursorChange.dispatch(1);
    }

    return (
        <div className='fire-control-elevatorGroup-container'>
            <SideBarTool
                activeBtnList={[SideBarBtnType.DELETE, SideBarBtnType.ADD]}
                onDeleteBtnClick={onDeleteClick}
                onAddBtnClick={onAddBtnClick}
            />
            <div className="elevatorGroup-side-title">全楼电梯</div>
            <div className='elevatorGroup-content-area'>
                <div className='elevatorGroup-content'>
                    {showAddElevatorGroup && (
                        <div className={classNames({
                            'elevatorGroup-row': true,
                            'elevatorGroup-row-active': true,
                        })}>
                            <div className='text-area'>
                                <Input
                                    value={editElevatorGroupName}
                                    onChange={(e) => setEditElevatorGroupName(e.target.value)}
                                    onPressEnter={onAddSave}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Escape') {
                                            setShowAddElevatorGroup(false);
                                            setEditElevatorGroupName("");
                                            setEditElevatorGroupUuid("");
                                        }
                                    }}
                                    placeholder='单击输入全楼电梯名称'
                                    autoFocus
                                />
                            </div>
                            <div className='icon-area' onClick={onAddSave}><ConfimSvg /></div>
                        </div>
                    )}
                    {displayElevatorGroups?.map((item, key) => (
                        <div
                            key={key}
                            className={classNames({
                                'elevatorGroup-row': true,
                                'elevatorGroup-row-active': activeElevatorGroup?.uuid === item.uuid,
                            })}
                            onClick={() => onElevatorGroupClick(item)}
                        >
                            <div className='text-area'>
                                {editElevatorGroupUuid !== item.uuid && `${item?.name}`}
                                {editElevatorGroupUuid === item.uuid && <Input
                                    value={editElevatorGroupName}
                                    onChange={(e) => setEditElevatorGroupName(e.target.value)}
                                    onPressEnter={onSave}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Escape') {
                                            setShowAddElevatorGroup(false);
                                            setEditElevatorGroupName("");
                                            setEditElevatorGroupUuid("");
                                            setShowBtnGroup(false);
                                            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.emptySelectedEntities.dispatch();
                                        }
                                    }}
                                    placeholder='单击输入全楼电梯名称'
                                    autoFocus
                                />}
                            </div>
                            {editElevatorGroupUuid !== item?.uuid && (
                                <div className='icon-list'>
                                    <EditSvg className='icon-area'
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onElevatorGroupEditClick(item);
                                        }} />
                                    {/* <LinkSvg className='icon-area' onClick={() => { onClickLink() }} /> */}
                                </div>
                            )}
                            {editElevatorGroupUuid === item?.uuid && <ConfimSvg onClick={onSave} />}
                        </div>
                    ))}
                </div>
            </div>
            {showBtnGroup && <div className='elevatorGroup-btn-group'>
                <div className="btn save" onClick={onSave}>确定</div>
                <div className="btn cancel" onClick={onCancel}>取消</div>
            </div>}
            {/* <SelectModal onConfirmClick={(e) => { onConfirmLink(e) }} data={tempFireControlElevatorGroupData} isOpen={modalOpen} setIsOpen={setModalOpen} /> */}

        </div>
    )
}